import React, { useState, useEffect } from "react";
import "./AddCourtPopup.css"; // reuse popup styles

export default function AddAdvocatePopup({ onAddAdvocate }) {
  const [showPopup, setShowPopup] = useState(false);
  const [courts, setCourts] = useState([]); // list of courts
  const [newAdvocate, setNewAdvocate] = useState({
    BarCouncilNo: "",
    Specialization: "",
    Name: "",
    Father_Name: "",
    Address: "",
    Contact_No: "",
    Whatsapp_contact_no: "",
    Personal_emailid: "",
    Official_emailid: "",
    Photo: "",
    Working_address: "",
    Chamber_no: "",
    Court_no: ""
  });

  // Fetch courts when popup opens
  useEffect(() => {
    if (showPopup) {
      const fetchCourts = async () => {
        try {
          const token = localStorage.getItem("token");
          const res = await fetch("http://localhost:5272/api/CourtMaster/GetCourt", {
            headers: { Authorization: `Bearer ${token}` },
          });

          if (res.ok) {
            const data = await res.json();
            setCourts(data);
          } else {
            console.error("Failed to fetch courts");
          }
        } catch (err) {
          console.error("Error fetching courts:", err);
        }
      };
      fetchCourts();
    }
  }, [showPopup]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Send courtId, not courtName
    await onAddAdvocate(newAdvocate);

    // reset form
    setNewAdvocate({ 
    BarCouncilNo: "",
    Specialization: "",
    Name: "",
    Father_Name: "",
    Address: "",
    Contact_No: "",
    Whatsapp_contact_no: "",
    Personal_emailid: "",
    Official_emailid: "",
    Photo: "",
    Working_address: "",
    Chamber_no: "",
    Court_no: "" 
});
    setShowPopup(false);
  };

  return (
    <div> 
      {/* Button to open popup */}
      <button onClick={() => setShowPopup(true)}>Add Advocate</button>

      {/* Popup */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-container">
            <h2 className="popup-title">Add Advocate</h2>
            <form onSubmit={handleSubmit} className="popup-form">
                <div className="form-grid">
              <input
                type="text"
                placeholder="BarCouncil No"
                value={newAdvocate.BarCouncilNo}
                onChange={(e) =>
                  setNewAdvocate({ ...newAdvocate, BarCouncilNo: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />
              <input
                type="text"
                placeholder="Specialization"
                value={newAdvocate.Specialization}
                onChange={(e) =>
                  setNewAdvocate({ ...newAdvocate, Specialization: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />
              <input
                type="text"
                placeholder="Advocate Name"
                value={newAdvocate.Name}
                onChange={(e) =>
                  setNewAdvocate({ ...newAdvocate, Name: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />
              <input
                type="text"
                placeholder="Father Name"
                value={newAdvocate.Father_Name}
                onChange={(e) =>
                  setNewAdvocate({ ...newAdvocate, Father_Name: e.target.value })
                }
                required
                    style={{ display: "block", margin: "10px 0", width: "100%" }}
              />
              <input
                type="text"
                placeholder="Address"
                value={newAdvocate.Address}
                onChange={(e) =>
                  setNewAdvocate({ ...newAdvocate, Address: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />
              <input
                type="text"
                placeholder="Contact No"
                value={newAdvocate.Contact_No}
                onChange={(e) =>
                  setNewAdvocate({ ...newAdvocate, Contact_No: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />
              <input
                type="text"
                placeholder="Whatsapp Contact No"
                value={newAdvocate.Whatsapp_contact_no}
                onChange={(e) =>
                  setNewAdvocate({ ...newAdvocate, Whatsapp_contact_no: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />
              <input
                type="text"
                placeholder="Personal Emailid"
                value={newAdvocate.Personal_emailid}
                onChange={(e) =>
                  setNewAdvocate({ ...newAdvocate, Personal_emailid: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />
              <input
                type="text"
                placeholder="Official Emailid"
                value={newAdvocate.Official_emailid}
                onChange={(e) =>
                  setNewAdvocate({ ...newAdvocate, Official_emailid: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />
              <input
                type="file"
                accept="image/*" // restrict to images (jpg/png), remove if you want any file
                onChange={(e) => setNewAdvocate({ ...newAdvocate, Photo: e.target.files[0] })}
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
                />
              <input
                type="text"
                placeholder="Working address"
                value={newAdvocate.Working_address}
                onChange={(e) =>
                  setNewAdvocate({ ...newAdvocate, Working_address: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />
              <input
                type="number"
                placeholder="Chamber No"
                value={newAdvocate.Chamber_no}
                onChange={(e) =>
                  setNewAdvocate({ ...newAdvocate, Chamber_no: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />

              {/* Dropdown for court selection */}
              <select
                value={newAdvocate.Court_no}
                onChange={(e) =>
                setNewAdvocate({ ...newAdvocate, Court_no: e.target.value })
                }
                required
                className="popup-select"
                >
                <option value="">-- Select Court --</option>
                {courts.map((court) => (
                <option key={court.courtId} value={court.courtId}>
                    {court.courtName} ({court.city})
                </option>))}
                </select>            
              <div className="popup-buttons">
                <button type="submit" className="btn-save">Save</button>
                <button
                  type="button"
                  className="btn-cancel"
                  onClick={() => setShowPopup(false)}
                  style={{ marginLeft: "10px" }}
                >
                  Cancel
                </button>
              </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
